import React, { Fragment, useState, useEffect } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validator from 'validator';

import Box from '@mui/material/Box';

import {
  Input,
  IconGraphy,
  Dropdown,
  DatePickerInput,
  Typography,
  Radio,
  colors,
  Button,
} from '@leapeasy/ui-kit';
import { setDataAction } from 'redux/actions/getFormActions';
import { CustomInputWrapper } from 'components/CustomWrapper';
import { validationMessages, rentAmountMessage } from 'utils/validationMessages';

const Form3 = (props) => {
  const { actions, formData, handleNext, handleBack } = props;
  const [data, setFormData] = useState({
    totalMthRent: null,
    leaseMates: null,
    roommateCount: 0,
    portionMthRent: null,
    leasePeriod: null,
    moveInDate: null,
  });
  const [roommateData, setRommmateData] = useState({});
  const [valid, setValid] = useState({
    '1_fname': true,
    '1_lname': true,
    '1_email': true,
    '1_phone': true,
    '2_fname': true,
    '2_lname': true,
    '2_email': true,
    '2_phone': true,
    '3_fname': true,
    '3_lname': true,
    '3_email': true,
    '3_phone': true,
  });

  useEffect(() => {
    setFormData({
      totalMthRent: formData.data.totalMthRent,
      leaseMates: formData.data.studentHousing ? 'No' : formData.data.leaseMates,
      roommateCount: formData.data.roommateCount || 0,
      portionMthRent: formData.data.portionMthRent,
      leasePeriod: formData.data.leasePeriod || 1,
      moveInDate: formData.data.moveInDate,
    });
    setRommmateData(formData.data.roommateData || {});
  }, [formData]);

  const handleChange = (e, label, validation) => {
    const value = e.target.value;
    console.log('label', label, value, value ===0 ? 'zero': 'none zero')
    if (label === 'leaseMates' && value === 'No') {
      setRommmateData({});
      setFormData({ ...data, portionMthRent: null, [label]: value });
    } else {
      setFormData({ ...data, [label]: value });
    }
  };

  const handleChangeRoommate = (e, label, validation) => {
    const value = e.target.value;
    setRommmateData({ ...roommateData, [label]: value });
    if (validation === 'email') {
      setValid({ ...valid, [label]: validator.isEmail(value) });
    }

    if (validation === 'phone') {
      setValid({
        ...valid,
        [label]: value.length === 14 || (value.length === 15 && value[0] === '+') ? true : false,
      });
    }
  };

  const validateRentAmount = (amount) => {
    return amount && amount >= 100 && amount <= 25000;
  };

  let disable = true;
  let sumOfPortion = data.portionMthRent;
  let sumValidation = true;
  if (data.leaseMates === 'Yes') {
    let rommateValidation = parseInt(data.roommateCount) > 0;

    for (let index = 0; index < parseInt(data.roommateCount); index++) {
      sumOfPortion += parseInt(roommateData[`${index + 1}_portionfee`]);
      const val =
        roommateData[`${index + 1}_fname`] &&
        roommateData[`${index + 1}_lname`] &&
        roommateData[`${index + 1}_phone`] &&
        roommateData[`${index + 1}_email`] &&
        roommateData[`${index + 1}_portionfee`] &&
        validateRentAmount(roommateData[`${index + 1}_portionfee`]) &&
        valid[`${index + 1}_fname`] &&
        valid[`${index + 1}_lname`] &&
        valid[`${index + 1}_phone`] &&
        valid[`${index + 1}_email`]
          ? true
          : false;
        console.log('roomatevalidatioin: ', roommateData[`${index + 1}_fname`],
          roommateData[`${index + 1}_lname`],
          roommateData[`${index + 1}_phone`],
          roommateData[`${index + 1}_email`],
          roommateData[`${index + 1}_portionfee`],
          validateRentAmount(roommateData[`${index + 1}_portionfee`]),
          valid[`${index + 1}_fname`],
          valid[`${index + 1}_lname`],
          valid[`${index + 1}_phone`],
          valid[`${index + 1}_email`])
      if (!val) {
        rommateValidation = val;
      }
    }

    sumValidation = data.totalMthRent === sumOfPortion;

    disable =
      // sumValidation &&
      rommateValidation &&
      data.portionMthRent &&
      data.totalMthRent &&
      data.moveInDate &&
      validateRentAmount(data.portionMthRent) &&
      validateRentAmount(data.totalMthRent)
        ? false
        : true;
      console.log('disable:', disable, rommateValidation, data.portionMthRent, data.totalMthRent, data.moveInDate, validateRentAmount(data.portionMthRent), validateRentAmount(data.totalMthRent))
    } else {
      disable =
      data.totalMthRent && data.moveInDate && validateRentAmount(data.totalMthRent) ? false : true;
      console.log('disable:', disable,data.totalMthRent,data.moveInDate,validateRentAmount(data.totalMthRent))
  }

  const handleNextButton = () => {
    actions.setDataAction({
      ...formData.data,
      totalMthRent: data.totalMthRent,
      leaseMates: data.leaseMates,
      roommateCount: data.leaseMates === 'No' ? 0 : data.roommateCount,
      portionMthRent: data.portionMthRent,
      leasePeriod: data.leasePeriod,
      roommateData,
      moveInDate: data.moveInDate,
    });
    handleNext();
  };

  return (
    <Fragment>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', flexGrow: 1 }}>

<CustomInputWrapper>
        <Input
          value={data.totalMthRent}
          onChange={(e) => {
            handleChange(e, 'totalMthRent');
          }}
          label="Total Monthly Rent"
          helperMessage={rentAmountMessage(data.totalMthRent, 'Total monthly rent')}
          type="number"
          errorType={
            data.totalMthRent === 0 ? 'error':
            data.totalMthRent && (data.totalMthRent < 100 || data.totalMthRent > 25000)
              ? 'error'
              : 'none'
          }
          icon={<IconGraphy icon="Finance.AttachMoney" />}
          minWidth="100%"
          size="medium"
          showCopy={false}
          fullWidth
        />
        </CustomInputWrapper>

        <Dropdown
          value={data.leasePeriod}
          size="medium"
          onChange={(e) => handleChange(e, 'leasePeriod')}
          options={new Array(18).fill(0).map((_, index) => ({
            text: `${index + 1} months`,
            value: index + 1,
          }))}
          multiselect={false}
          placeholder="Select item"
          label="Lease Term"
          showSearch={true}
          icon={
            <IconGraphy
              icon="TimeDate.CalendarToday"
              width={12}
              height={12}
              style={{ color: 'black' }}
            />
          }
          iconVisible
          style={{
            minWidth: '100%',
          }}
        />
        {/* <CustomInputWrapper> */}
        <Box
          className="rg-datepicker"
          sx={{ position: 'relative', zIndex: 10, overflow: 'visible' }}
        >
          <DatePickerInput
            label="Move In Date"
            value={data.moveInDate || ''}
            onChange={(e) => handleChange(e, 'moveInDate')}
            minWidth="100%"
            size="medium"
            minDate="01/01/2020"
            fullWidth
            showActionButtons
            showHelperMessage
          />
        </Box>
        {/* </CustomInputWrapper> */}
        {!formData.data.studentHousing && (
          <Box mb={2}>
            <Typography variant="body1" style={{ color: colors.purple[900], fontWeight: '400' }}>
              Will anybody else be on this lease?
            </Typography>

            <Box display="flex" alignItems="flex-start" sx={{ gap: '24px', marginTop: 2 }}>
              <Radio
                label="Yes"
                value={data.leaseMates === 'Yes'}
                onChange={(_) => handleChange({ target: { value: 'Yes' } }, 'leaseMates')}
              />
              <Radio
                label="No"
                value={data.leaseMates === 'No'}
                onChange={(_) => handleChange({ target: { value: 'No' } }, 'leaseMates')}
              />
            </Box>
          </Box>
        )}

        {data.leaseMates === 'Yes' && (
          <>
          <CustomInputWrapper>
            <Input
              value={data.portionMthRent}
              onChange={(e) => handleChange(e, 'portionMthRent')}
              label="Your Rent Portion"
              helperMessage={rentAmountMessage(data.portionMthRent, 'Your rent portion')}
              type="number"
              errorType={
                data.portionMthRent === 0 ? 'error':
                data.portionMthRent && (data.portionMthRent < 100 || data.portionMthRent > 25000)
                  ? 'error'
                  : 'none'
              }
              icon={<IconGraphy icon="Finance.AttachMoney" />}
              minWidth="100%"
              size="medium"
              showCopy={false}
              fullWidth
            />
</CustomInputWrapper>
            <Box display="flex" flexDirection="column" sx={{ gap: '12px' }}>
              <Typography variant="body1" style={{ color: colors.purple[900] }}>
                How many additional Tenants will be on this lease?
              </Typography>

              <Dropdown
                value={data.roommateCount}
                size="medium"
                onChange={(e) => handleChange(e, 'roommateCount')}
                options={[
                  {
                    text: '1',
                    value: 1,
                  },
                  {
                    text: '2',
                    value: 2,
                  },
                  {
                    text: '3',
                    value: 3,
                  },
                ]}
                multiselect={false}
                placeholder="Select item"
                showSearch={false}
                icon={
                  <IconGraphy
                    icon="Users.Group"
                    width={12}
                    height={12}
                    style={{ color: 'black' }}
                  />
                }
                iconVisible
                style={{
                  minWidth: '100%',
                }}
              />
            </Box>

            {new Array(parseInt(data.roommateCount)).fill(0).map((item, index) => (
              <Box key={index} display="flex" flexDirection="column" sx={{ gap: '4px' }}>
                <Typography variant="body1" style={{ color: colors.purple[900] }}>
                  Tenant {index + 2}{' '}
                </Typography>

                <CustomInputWrapper>
                  <Input
                    value={roommateData[`${index + 1}_fname`]}
                    onChange={(e) => handleChangeRoommate(e, `${index + 1}_fname`, 'fname')}
                    label="First Name"
                    type="text"
                    helperMessage={
                      !valid[`${index + 1}_fname`] &&
                      roommateData[`${index + 1}_fname`] &&
                      validationMessages.firstName
                    }
                    errorType={
                      !valid[`${index + 1}_fname`] && roommateData[`${index + 1}_fname`]
                        ? 'error'
                        : 'none'
                    }
                    icon={<IconGraphy icon="Users.User" />}
                    minWidth="100%"
                    size="medium"
                    showCopy={false}
                    fullWidth
                    />
                    </CustomInputWrapper>

                    <CustomInputWrapper>
                  <Input
                    value={roommateData[`${index + 1}_lname`]}
                    onChange={(e) => handleChangeRoommate(e, `${index + 1}_lname`, 'lname')}
                    label="Last Name"
                    type="text"
                    helperMessage={
                      !valid[`${index + 1}_lname`] &&
                      roommateData[`${index + 1}_lname`] &&
                      validationMessages.lastName
                    }
                    errorType={
                      !valid[`${index + 1}_lname`] && roommateData[`${index + 1}_lname`]
                        ? 'error'
                        : 'none'
                    }
                    icon={<IconGraphy icon="Users.User" />}
                    minWidth="100%"
                    size="medium"
                    showCopy={false}
                    fullWidth
                  />
                </CustomInputWrapper>
                <CustomInputWrapper>
                <Input
                  value={roommateData[`${index + 1}_email`]}
                  onChange={(e) => handleChangeRoommate(e, `${index + 1}_email`, 'email')}
                  label="Contact Email"
                  helperMessage={
                    !valid[`${index + 1}_email`] &&
                    roommateData[`${index + 1}_email`] &&
                    validationMessages.email
                  }
                  type="email"
                  errorType={
                    !valid[`${index + 1}_email`] && roommateData[`${index + 1}_email`]
                      ? 'error'
                      : 'none'
                  }
                  icon={<IconGraphy icon="Notifications.Email" />}
                  minWidth="100%"
                  size="medium"
                  showCopy={false}
                  fullWidth
                />
</CustomInputWrapper><CustomInputWrapper>
                <Input
                  value={roommateData[`${index + 1}_phone`] || ''}
                  onChange={(e) => handleChangeRoommate(e, `${index + 1}_phone`, 'phone')}
                  label="Contact Phone Number"
                  helperMessage={
                    !valid[`${index + 1}_phone`] &&
                    roommateData[`${index + 1}_phone`] &&
                    validationMessages.phone
                  }
                  type="tel"
                  errorType={
                    !valid[`${index + 1}_phone`] && roommateData[`${index + 1}_phone`]
                      ? 'error'
                      : 'none'
                  }
                  minWidth="100%"
                  size="medium"
                  // phoneCountry="US"
                  showCopy={false}
                  fullWidth
                />
</CustomInputWrapper>
<CustomInputWrapper>
                <Input
                  value={roommateData[`${index + 1}_portionfee`]}
                  onChange={(e) => handleChangeRoommate(e, `${index + 1}_portionfee`, 'fee')}
                  label="Portion of Monthly Rent"
                  helperMessage={rentAmountMessage(
                    roommateData[`${index + 1}_portionfee`],
                    'Portion of monthly rent',
                  )}
                  type="number"
                  errorType={
                    roommateData[`${index + 1}_portionfee`] === 0 ? 'error':
                    roommateData[`${index + 1}_portionfee`] &&
                    (roommateData[`${index + 1}_portionfee`] < 100 ||
                      roommateData[`${index + 1}_portionfee`] > 25000)
                      ? 'error'
                      : 'none'
                  }
                  icon={<IconGraphy icon="Finance.AttachMoney" />}
                  minWidth="100%"
                  size="medium"
                  showCopy={false}
                  fullWidth
                /></CustomInputWrapper>
              </Box>
            ))}
          </>
        )}
      </Box>

      <Box
        sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', mt: 4, gap: '16px' }}
      >
        <Button size="medium" variant="secondary" onClick={handleBack} style={{ flexShrink: 2 }}>
          Back
        </Button>

        <Button
          size="medium"
          variant="primary"
          onClick={handleNextButton}
          disabled={disable}
          style={{ flexShrink: 1 }}
        >
          Next
        </Button>
      </Box>
    </Fragment>
  );
};

const CustomBox = styled(Box)`
  display: flex;
  gap: 24px;
  & > div {
    & > div:nth-of-type(2) {
      & > div:nth-of-type(1) {
        input {
          width: 40px;
        }
      }
    }
  }
`;

const mapStateToProps = (state) => {
  return {
    formData: state.formData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      {
        setDataAction,
      },
      dispatch,
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Form3);
